import React, { createContext, useContext } from "react";

import useContextController from "contexts/useContextController";

import {
  ProviderProps,
  ContextValue,
  State,
} from "components/bookShuffle/useBookShuffle/types";
import defaultState from "components/bookShuffle/useBookShuffle/constants";
import * as reducerFunctions from "components/bookShuffle/useBookShuffle/reducers";
import methodHooks from "components/bookShuffle/useBookShuffle/hooks";

interface Props extends ProviderProps {
  children: React.ReactNode;
}

export function Provider(props: Props) {
  const { children, books = [], ...passedProps } = props;

  const initialState = defaultState({
    // overrides
    books,
  });
  const value: ContextValue = useContextController<State, ContextValue>(
    initialState,
    reducerFunctions,
    methodHooks,
    passedProps
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

/**
 * A convenience hook for accessing the context value
 */
export default function useView() {
  return useContext(Context);
}

const Context = createContext<ContextValue>({} as ContextValue);

export { Context };
